import { FC } from 'react'
import { TheatricalReleaseResult } from '@/services/Theatrical/queries'
import { TicketPromoBanners } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/DiscountBanner/TicketPromoBanners'

interface BannerSectionProps {
  isEditReservationFlow: boolean
  theatricalRelease: TheatricalReleaseResult
}

const TicketBannerSection: FC<BannerSectionProps> = ({ isEditReservationFlow, theatricalRelease }) => {
  if (isEditReservationFlow || !theatricalRelease?.theatricalSlug) return null

  return (
    <TicketPromoBanners
      theatricalSlug={theatricalRelease?.theatricalSlug}
      projectName={theatricalRelease?.title ?? ''}
    />
  )
}

export default TicketBannerSection
